module.exports = __webpack_public_path__ + "img/VALOR_CONFIANZA2.cf1e0f73.png";